<template lang="pug">
  .kpi
    loading(v-if="isLoading")
    bar-chart(
      v-if="!isLoading"
      :isHorizontal="isHorizontal"
      :series="empleadosSeries"
      :categories="areas"
      :yAxisTitle="isHorizontal ? 'Areas' : 'Empleados'"
      :tooltipFormatter="tooltipFormatter"
      :xAxisTitle="!isHorizontal ? 'Areas' : 'Empleados'"
      title="Cantidad de Empleados por Area"
      :showLegend="false"
      :showXlabels="true"
    )
    //- pie-chart(
    //-   title="Cantidad de Empleados por Area"
    //- )
</template>

<script>
import { apiGet } from '../../util/general';
import BarChart from '../charts/c_chart_bar';
import PieChart from '../charts/c_chart_pie.vue';

export default {
  name: 'empleados_por_area',
  components: {
    'bar-chart':BarChart,
    'pie-chart':PieChart
  },
  props: {
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // Datos para el gráfico de empleados por área
      areas: [],
      empleadosSeries: [
        {
          name: 'Cantidad de Empleados',
          data: []
        }
      ],
      seriesPie:[],
      isLoading:true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    tooltipFormatter (val) {
      return `${val} empleados`;
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/kpi/empleados-por-area', {}, function (data) {
        vm.areas = []
        vm.empleadosSeries[0].data = []
        for (let index = 0; index < data.lista.length; index++) {
          const element = data.lista[index];
          vm.areas.push(element.area)
          vm.empleadosSeries[0].data.push(element.cantidadEmpleados)
          vm.seriesPie.push(element.cantidadEmpleados)
        }
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
/* Puedes agregar estilos personalizados aquí si es necesario */
.kpi
  display flex
  flex-direction column
  gap 20px
  padding 20px
  box-sizing border-box
</style>



// WEBPACK FOOTER //
// c_kpi_empleado_por_areas.vue?96f28306